// «Dólares» en VITRINA y CLASE SUELTA (Mabel 10-oct-2026, video: «en vitrina no aparece la opción de dólares;
// clase suelta tampoco»). La venta se registra en PESOS como siempre (precio de la vitrina / de la clase) y
// los dólares entran a la caja como cambio de divisa («Entraron dólares»): salen usd × TC en pesos y quedan los
// USD. Así sirve igual si pagan justo, con cambio en pesos o parte en pesos y parte en dólares.
import { useEffect, useState } from 'react';
import { addEntradaDolares, getTipoCambio, pesosDeDolares, money } from '../api';

export const METODO_DOLARES = 'cash_usd';

export function useDolares() {
  const [usd, setUsd] = useState('');
  const [tc, setTc] = useState(17);
  useEffect(() => { getTipoCambio().then(setTc).catch(() => {}); }, []);
  return { usd, setUsd, tc, setTc, usdNum: Number(usd) || 0 };
}

/** Registra los dólares en la caja tras cobrar. Devuelve un aviso si no se pudo (la venta ya quedó en pesos). */
export async function registrarDolares(usd: number, tc: number, nota: string, setTc?: (n: number) => void): Promise<string | null> {
  try { await addEntradaDolares(usd, tc, nota.slice(0, 120)); return null; }
  catch (e: any) {
    if (e?.status === 409 && e?.data?.fx_rate) setTc?.(Number(e.data.fx_rate));
    return `La venta quedó registrada, pero los dólares no entraron a la caja (${e?.message || 'error'}). Regístralos con «Entraron dólares» en la Caja.`;
  }
}

export default function DolaresMostrador({ total, usd, setUsd, tc }: { total: number; usd: string; setUsd: (v: string) => void; tc: number }) {
  const pesos = pesosDeDolares(Number(usd) || 0, tc);
  const diff = Math.round((pesos - total) * 100) / 100;
  return (
    <div data-testid="dolares-mostrador" className="mb-2 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-2.5 text-sm">
      <div className="flex items-center gap-2">
        <span className="text-content-2">Te dio</span>
        <input data-testid="dolares-input" inputMode="decimal" autoFocus value={usd} placeholder="0"
          onChange={(e) => setUsd(e.target.value.replace(/[^\d.]/g, ''))}
          className="w-20 rounded border border-line bg-surface px-2 py-1 text-right text-content outline-none focus:border-brand-blue" />
        <span className="text-content-2">USD × {tc} = <b className="text-content">{money(pesos)}</b></span>
      </div>
      {Number(usd) > 0 && (
        <p data-testid="dolares-cambio" className={`mt-1 text-xs font-semibold ${diff >= 0 ? 'text-emerald-700 dark:text-emerald-300' : 'text-amber-700 dark:text-amber-300'}`}>
          {diff > 0 ? `Cambio en pesos: ${money(diff)}` : diff === 0 ? 'Justo, sin cambio' : `Faltan ${money(-diff)} en pesos (que complete con pesos)`}
        </p>
      )}
    </div>
  );
}
